import { useCallback, useRef } from 'react';

const useScrollToElement = () => {
  const elementRefs = useRef<Map<string, HTMLElement>>(new Map());

  const registerElement = useCallback((id: string, element: HTMLElement | null) => {
    if (element) {
      elementRefs.current.set(id, element);
    } else {
      elementRefs.current.delete(id);
    }
  }, []);

  const scrollToElement = useCallback((id: string) => {
    const element = elementRefs.current.get(id);
    if (element) {
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      element.scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
      });
    }
  }, []);

  return { registerElement, scrollToElement };
};

export default useScrollToElement;
